<script lang="ts">
    import { tgettext } from 'hydria/services/gettext'

    import SimpleListingWithPagination from 'hydria/components/SimpleListings/SimpleListingWithPagination.svelte'

    const singular = 'nouvelle_client'
    const plural = 'nouvelles_client'
    const baseUrl = '/nouvelles_client'

    const pageTitle = tgettext('Nouvelles client')
    const createButtonText = tgettext('Ajouter une nouvelle')
    const pageDescMd = tgettext('(affichées dans le tableau de bord des clients connectés)')

    interface Props {
        route: any
    }

    let { route }: Props = $props()
</script>

<SimpleListingWithPagination {route} {singular} {plural} {baseUrl} {pageTitle} {createButtonText} {pageDescMd} />
